import { useEffect, useState } from "react";
import { CHAT_URL } from "../../../../config/app-config";

function GroupEditModal({ visible, onClose, group, onSave, userList }) {
  const [groupName, setGroupName] = useState("");
  const [description, setDescription] = useState("");
  const [members, setMembers] = useState([]);
  const [groupImage, setGroupImage] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (group) {
      setGroupName(group.name || "");
      setDescription(group.description || "");
      setMembers(group.members || []);
      setPreviewImage(
        group.groupImage ? `${CHAT_URL}api/getImage/${group.groupImage}` : ""
      );
    }
  }, [group]);

  const handleRemoveMember = (userId) => {
    setMembers(members.filter((m) => m.userId !== userId));
  };

  const handleAddMember = (user) => {
    if (!members.find((m) => m.userId === user.userId)) {
      setMembers([...members, { ...user, role: "member" }]);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setGroupImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("groupId", group._id);
    formData.append("groupName", groupName);
    formData.append("description", description);
    formData.append("members", JSON.stringify(members));
    if (groupImage) {
      formData.append("groupImage", groupImage);
    }
    onSave(formData);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: "600px",
          maxHeight: "80vh",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px 20px",
            background: "#2563eb",
            color: "#fff",
            fontSize: "18px",
            fontWeight: "600",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Edit Group</span>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "20px",
          }}
        >
          {/* Group Name */}
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Group Name
            </label>
            <input
              type="text"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="Enter group name"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Description */}
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Description
            </label>
            <textarea
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                fontSize: "14px",
                resize: "none",
              }}
            />
          </div>

          {/* Group Image */}
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Group Image
            </label>
            <input type="file" onChange={handleImageChange} />
            {previewImage && (
              <img
                src={previewImage}
                alt="Group Preview"
                style={{
                  width: "100px",
                  marginTop: "10px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
            )}
          </div>

          {/* Current Members */}
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Current Members
            </label>
            {members.length > 0 ? (
              members.map((m) => (
                <div
                  key={m.userId}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 10px",
                    marginBottom: "6px",
                    background: "#f9fafb",
                    borderRadius: "6px",
                  }}
                >
                  <span>{m.userName}</span>
                  <button
                    onClick={() => handleRemoveMember(m.userId)}
                    style={{
                      background: "#ef4444",
                      border: "none",
                      color: "#fff",
                      padding: "6px 10px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>
              ))
            ) : (
              <div style={{ color: "#6b7280", fontSize: "14px" }}>
                No members yet
              </div>
            )}
          </div>

          {/* Add Members */}
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Add Members
            </label>
            <input
              type="text"
              placeholder="Search users..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                fontSize: "14px",
                marginBottom: "8px",
              }}
            />
            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #e5e7eb",
                padding: "8px",
                borderRadius: "6px",
              }}
            >
              {userList
                .filter((u) => {
                  const firstName = u.firstName || "";
                  const lastName = u.lastName || "";
                  return (
                    firstName.toLowerCase().includes(search.toLowerCase()) ||
                    lastName.toLowerCase().includes(search.toLowerCase())
                  );
                })
                .map((u) => {
                  const alreadyAdded = members.some(
                    (m) => m.userId === u.userId
                  );
                  return (
                    <div
                      key={u.userId}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "6px 10px",
                        marginBottom: "4px",
                        background: "#f3f4f6",
                        borderRadius: "6px",
                        fontSize: "14px",
                      }}
                    >
                      <span>
                        {(u.firstName || "") + " " + (u.lastName || "")}
                      </span>
                      <button
                        disabled={alreadyAdded}
                        onClick={() => handleAddMember(u)}
                        style={{
                          background: alreadyAdded ? "#9ca3af" : "#10b981",
                          border: "none",
                          color: "#fff",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          cursor: alreadyAdded ? "not-allowed" : "pointer",
                        }}
                      >
                        {alreadyAdded ? "Added" : "Add"}
                      </button>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "14px 20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            borderTop: "1px solid #e5e7eb",
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: "#6b7280",
              border: "none",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: "8px",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{
              background: "#2563eb",
              border: "none",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Update Group
          </button>
        </div>
      </div>
    </div>
  );
}

export default GroupEditModal;
